import { render, staticRenderFns } from "./FilesandMediaList.vue?vue&type=template&id=79177e74&"
import script from "./FilesandMediaList.vue?vue&type=script&lang=js&"
export * from "./FilesandMediaList.vue?vue&type=script&lang=js&"
import style0 from "./FilesandMediaList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports